import React from 'react';

const Team = props => (
  <section>
    <div className="container">
      <div className="row">
        <div className="col-12 text-center ">
          <h1 className="">{props.clanovi.title}</h1>
          <div className="u-h-4 u-w-50 bg-white rounded mx-auto my-4" />
        </div>
      </div>
      <div className="row align-items-center ">
        {props.clanovi.list.map(({ name, photo, role, drives }) => (
          <div className="col-lg-4 text-center mt-4">
            <img className="w-100 rounded box-shadow-v1" src={photo} alt={name} />
            <div className="my-md-4">
              <h4 className="mb-0">{name}</h4>
              <p className="text-muted mb-0">{role}</p>
              <p className="my-4" />
              {/* <ul className="list-inline social social-rounded social-default social-sm">
                <li className="list-inline-item">
                  <a href="">
                    <i className="fa fa-facebook" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="">
                    <i className="fa fa-twitter" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="">
                    <i className="fa fa-google-plus" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="">
                    <i className="fa fa-linkedin" />
                  </a>
                </li>
              </ul> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Team;



// WEBPACK FOOTER //
// ./src/components/Team.js